import classNames from 'classnames';
import Image from '../../Atoms/Image';

interface Props {
  bg?: string;
  bgImg?: string;
  /** @defaultValue 'center' */
  bgPosition?: 'center' | 'bottom' | 'top';
  bgSize?: 'contain' | 'cover';
  bgOverlayMode?: boolean;
  rounded?: boolean;
  children?:
    | JSX.Element
    | JSX.Element[]
    | string
    | string[];
  fluidContainer?: boolean;
  className?: string;
}

function Promo({
  bg = 'linear-gradient(225deg, rgba(35, 39, 91, 0.75) 0%, rgba(73, 79, 148) 100%)',
  bgImg,
  bgPosition = 'center',
  bgSize = 'cover',
  bgOverlayMode = false,
  rounded = true,
  children,
  fluidContainer,
  className
}: Props) {
  const bgProp = bgImg
    ? `url(${bgImg}) no-repeat ${bgPosition}/${bgSize}, ${bg}`
    : `${bg}`;
  return (
    <section
      className={classNames([
        'relative overflow-hidden md:mx-7',
        {
          'rounded-xl': rounded
        },
        className
      ])}
    >
      {bgImg && bgOverlayMode && (
        <Image
          className={classNames([
            'absolute inset-0 z-10 h-full w-full',
            bgPosition === 'center' && 'object-center',
            bgPosition === 'bottom' && 'object-bottom',
            bgPosition === 'top' && 'object-top',
            bgSize === 'cover' && 'object-cover',
            bgSize === 'contain' && 'object-contain'
          ])}
          src={bgImg}
          alt=""
        />
      )}

      <div
        className={classNames([
          'relative z-20 py-14 md:py-20 lg:py-28'
        ])}
        style={{
          background: !bgOverlayMode ? bgProp : bg
        }}
      >
        <div
          className={classNames([
            'mx-auto px-7',
            fluidContainer ? 'max-w-full' : 'max-w-7xl'
          ])}
        >
          {children}
        </div>
      </div>
    </section>
  );
}

export default Promo;
